import { client } from "@/api/client";
import interceptors from "@/api/interceptors";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getExpedition(params) {
	return client.get("api-logistic/shipment/data", {
		params: params,
	});
}

export default {
	getExpedition,
};